export default __webpack_public_path__ + "static/嘉宾头像_汪洋-1aa4118c8fce92e844ea9351f6ba23bd.png";